document.addEventListener('DOMContentLoaded', function () {
  var mehr = document.getElementById('mehr-btn');
  var weniger = document.getElementById('weniger-btn');
  var inhalt = document.getElementById('mehr-inhalt');

  if (!mehr || !weniger || !inhalt) return;

  mehr.addEventListener('click', function (e) {
    e.preventDefault();
    inhalt.style.display = 'block';
    mehr.style.display = 'none';
    weniger.style.display = 'inline';
  });

  weniger.addEventListener('click', function (e) {
    e.preventDefault();
    inhalt.style.display = 'none';
    mehr.style.display = 'inline';
    weniger.style.display = 'none';
  });
});
